import React from 'react'
import { Link } from 'react-router-dom'
import EventAdd from './EventAdd'

class EventAddTab extends React.Component {
  state = {
    language_data: [],
  }

  componentDidMount() {
    if (
      this.props.match.params.event_id !== undefined &&
      this.props.match.params.event_id !== null &&
      this.props.match.params.event_id !== 0 &&
      this.props.match.params.event_id !== ''
    ) {
      this.setState({ event_id: this.props.match.params.event_id })
    }
  }

  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.event_id ? 'Edit' : 'Add'} Event</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/Event">Event</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.event_id ? 'Edit' : 'Add'} Event
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'Event_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.event_id !== undefined &&
                        this.state.event_id !== null &&
                        this.state.event_id !== 0 &&
                        this.state.event_id !== '' ? (
                          <EventAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            event_id={this.props.match.params.event_id}
                          />
                        ) : (
                          <EventAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            event_id={this.props.match.params.event_id}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventAddTab
